module.exports = __webpack_public_path__ + "static/sebastian-introduction-fb3e31da316f4b5014a7530d72bf48e5.jpg";